import { useState } from 'react';
import { useSearchParamsWithApiKey, useDebouncedEffect } from '../../tools';

const PROMPT_PARAM = 'prompt';
const STYLE_PARAM = 'style';

interface UseGeneratePatternParams {
    prompt: string;
    style: string;
    setPrompt: (prompt: string) => void;
    setStyle: (style: string) => void;
}

export const useGeneratePatternParams = (): UseGeneratePatternParams => {
    const [, setSearchParams] = useSearchParamsWithApiKey();
    const [prompt, setPrompt] = useState<string>('');
    const [style, setStyle] = useState<string>('');

    useDebouncedEffect(
        () => {
            const searchParamsObj: Record<string, string | string[]> = {};
            if (prompt) {
                searchParamsObj[PROMPT_PARAM] = prompt;
            }
            if (style) {
                searchParamsObj[STYLE_PARAM] = style;
            }

            setSearchParams(searchParamsObj);
        },
        [prompt, style, setSearchParams],
        500,
    );

    return {
        prompt,
        style,
        setPrompt,
        setStyle,
    };
};
